// src/pages/Home.js
import React, { useEffect, useState } from 'react';
import { db } from '../firebaseConfig';
import { doc, onSnapshot } from 'firebase/firestore';
import '../styles/BellaBizarreStyle.css';

export default function Home() {
    const [quote, setQuote] = useState('');
    const [imgUrl, setImgUrl] = useState('');
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const d = doc(db, 'siteContent', 'home');
        const unsub = onSnapshot(d, (snap) => {
            const data = snap.data();
            setQuote(data?.quote || '');
            setImgUrl(data?.featureImageUrl || '');
            setLoading(false);
        }, () => setLoading(false));
        return unsub;
    }, []);

    if (loading) {
        return <div className="home-container"><p>Loading…</p></div>;
    }

    return (
        <div className="home-container">
            <h1 id='bella-bizarre-title'>Bella Bizarre</h1>
            <div className="home-text-container fade-in">
                <div className="home-logo-container">
                {imgUrl ? (
                    <img id="bella-bizarre-home-image" src={imgUrl} alt="Feature" />
                ) : null}

                    <h3>Quote</h3>

                </div>
                <div className='wisp-of-the-day-container'>
                    <h1 className='wisp-of-the-day-text'>Quote of the Day</h1>
                    {quote && <h2 className='wisp-of-the-day-text'>&ldquo;{quote}&rdquo;</h2>}
                </div>
            </div>
        </div>
    );
}
